import { render, staticRenderFns } from "./Salesperformancedatapercustomer.vue?vue&type=template&id=51ccfbd0&scoped=true&"
import script from "./Salesperformancedatapercustomer.vue?vue&type=script&lang=js&"
export * from "./Salesperformancedatapercustomer.vue?vue&type=script&lang=js&"
import style0 from "./Salesperformancedatapercustomer.vue?vue&type=style&index=0&id=51ccfbd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccfbd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ccfbd0')) {
      api.createRecord('51ccfbd0', component.options)
    } else {
      api.reload('51ccfbd0', component.options)
    }
    module.hot.accept("./Salesperformancedatapercustomer.vue?vue&type=template&id=51ccfbd0&scoped=true&", function () {
      api.rerender('51ccfbd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/sales/Salesperformancedatapercustomer.vue"
export default component.exports